import { Container, Link, Stack, Text } from "basis";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";
import { ScreenProps } from "./types";

export const FinalDecline = ({ state: { accountInfo } }: ScreenProps) => (
  <Stack gap="8">
    <Container bg="grey.t05" padding="4">
      <CreditCard
        cardName={accountInfo.cardName}
        cardEndsWith={accountInfo.cardEndsWith}
      />
    </Container>
    <SvgInline name="close-account" size="92" />
    <Text as="h4" textStyle="heading4">
      Thanks for your interest in increasing your credit limit
    </Text>
    <Text>
      Based on the information you provided, we’re unable to increase your
      credit limit at this time.
    </Text>
    <Text>
      Should your financial circumstances change in the future, you’re welcome
      to re-apply after 30 days.
    </Text>
    <Link
      appearance="primary-button"
      variant="blue-button"
      width="216"
      href="/manage-account"
      newTab={false}
    >
      Manage account
    </Link>
  </Stack>
);
